import Apollo from '@/graphql/vue-apollo'

import { UpdateCurrentBusiness, CurrentBusiness } from '@/graphql/local/business.graphql'

import { LOCAL_STORAGE_CURRENT_BUSINESS_ID } from '@/consts/local-storage'

export default {
  setCurrentBusinessData: async function(businessId) {
    let business = {
      id: businessId
    }
    localStorage.setItem(LOCAL_STORAGE_CURRENT_BUSINESS_ID, business.id)

    await Apollo.instance.defaultClient.mutate({
      mutation: UpdateCurrentBusiness,
      variables: {
        business
      }
    })
  },
  getCurrentBusiness: function() {
    let result = Apollo.instance.defaultClient.readQuery({
      query: CurrentBusiness
    })

    return result.localBusiness
  },
  loadLocalState: async function() {
    let currentBusinessId = localStorage.getItem(LOCAL_STORAGE_CURRENT_BUSINESS_ID)

    if (currentBusinessId !== null) {
      await this.setCurrentBusinessData(currentBusinessId)
    }
  },
  emptyLocalState: async function() {
    localStorage.removeItem(LOCAL_STORAGE_CURRENT_BUSINESS_ID)
  }
}
